import {$, Resource} from 'simpli-web-sdk'
import {DocumentType as DocType} from '@/enums/DocumentType'

export class DocumentType extends Resource {
  idDocumentTypePk: number | null = null

  description: string | null = null

  get $id() {
    return this.idDocumentTypePk ?? 0
  }
  set $id(val) {
    this.idDocumentTypePk = val || 0
  }
  get $tag() {
    return String(this.description)
  }

  get documentTranslated() {
    if (this.$id === DocType.RUT) {
      return $.t('enums.DocumentType.RUT')
    } else if (this.$id === DocType.OTHER) {
      return $.t('enums.DocumentType.OTHER')
    } else {
      return $.t('app.notInformed')
    }
  }
}
